var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline border btn-sm",attrs:{"type":"button"},on:{"click":_vm.onClickCancel}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }